import {DisputeOrderInfo} from './dispute-order-info';
import { CopyToUser } from './copy-to-users.interface';
export class CreateTicketRequest {
    operatingCountryId: number;
    source: string;
    callerName: string;
    callerPhoneNumber: number;
    ticketType: string;
    subType: string;
    orderId: string;
    orderReasonReasonId: string;
    departmentName: string;
    assignedToId: number;
    assignedToValue: string;
    isAssignedToMe: boolean;
    priorityId: number;
    dueDate: Date;
    subject: string;
    description: string;
    status: string;
    statusId:number;
    priority:string;
    typeId:number;
    subTypeId:number;
    departmentId:number;
    memberId:string;
    memberType:any;
    sourceId:number;
    sourceIdentifierValue:string;
    note:string;
    disputeTypeId?: number;
    filePath: Array<string>;
    id:number;
    ticketNumber:string;
    createdBy:number;
    updatedBy:number;
    notes:any[];
    attachments:any[];
    closeReasonId:number;
    closeReason:string;
    userId:number;
    reopenReason:string;
    ticketId:number;
    firstName:string;
    lastName:string;
    disputes:DisputeOrderInfo[];
    locationTypeId:number;
    orderReasonNotes:string;
    copyToUsers?: CopyToUser[];
    distributorName;
    assignedToEmail:string;
    agentName:string;
    agentEmail:string;
    ticketLink:string;
    sendMailNotification:boolean;
    closeOtherReason:string;
    countryId?: number;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/ticket-create.ts